import state from './state'
import actionTypes from './actionTypes'
import actions from './actions'
import mutations from './mutations'

import type { CodesDetail, ProductParams } from '@/api/model/basicTypes'

export { actionTypes }

export interface State {
  // フォルダ名
  folderName: string
  // ファイル名
  fileName: string

  // ドキュメント種別
  documentTypeInfo: CodesDetail
  documentType: string
  productTable: any

  // 商品一覧画面・検索条件
  productListParam: ProductParams
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
}
